const LandingPageButton = ( {children, onClick} ) => {
    return (
        <div onClick={onClick} className="cursor-pointer bg-white text-grey-900 w-fit m-auto px-[14.5px] lg:px-[24.5px] h-[49px] grid items-center font-regular text-[16px] poppins-medium leading-[26px] rounded-[12px]">
            {children}
        </div>
    )
}
export default LandingPageButton;